import { calculateRatio, isValidNumber } from "./shared";

export const cameriereValidator = (getFieldValue) => ({
  validator(_, value) {
    const pulp = getFieldValue("pulp_area");
    const tooth = getFieldValue("tooth_area");

    if (!value) return Promise.reject(new Error("This field is required"));
    if (!isValidNumber(value))
      return Promise.reject(new Error("Only numbers and '.' allowed"));
    if (!pulp || !tooth) return Promise.resolve();

    if (parseFloat(pulp) >= parseFloat(tooth)) {
      return Promise.reject(
        new Error("Tooth area must be greater than pulp area")
      );
    }

    const ratio = calculateRatio(pulp, tooth);
    if (ratio <= 0.001 || ratio >= 0.2) {
      return Promise.reject(
        new Error("Pulp-to-Tooth ratio must be between 0.001 and 0.2")
      );
    }

    return Promise.resolve();
  },
});
